export const PLAY = 'PLAY';
export const UPDATE_NODE = 'UPDATE_NODE';
export const UPDATE_NODES_ARRAY = 'UPDATE_NODES_ARRAY';
export const UPDATE_SETTINS = 'UPDATE_SETTINS';
export const START_PLAY = 'START_PLAY';
export const STOP_PLAY = 'STOP_PLAY';
export const MOVE_PLAYHEAD = 'MOVE_PLAYHEAD';
export const UPDATE_SOUND = 'UPDATE_SOUND';
export const TOGGLE_EQ = 'TOGGLE_EQ';
export const CHANGE_BAND = 'CHANGE_BAND';
export const RESET_BANDS = 'RESET_BANDS';
export const CHANGE_ECHO = 'CHANGE_ECHO';
